import { getMetadata } from '../../utils/api/metadata';
import {
  metadataFetching,
  metadataSucceeded,
  metadataFailed,
} from './slice';
import { setAlert } from '../alerts/slice';
import ALERT_TYPES from '../alerts/constants';

export const getApplicationMetadata = () => async (dispatch) => {
  try {
    dispatch(metadataFetching());
    const result = await getMetadata();
    dispatch(metadataSucceeded(result.data.model));
  } catch (error) {
    dispatch(setAlert({
      type: ALERT_TYPES.error,
      message: 'Failed to fetch application metadata',
    }));
    dispatch(metadataFailed(error.status, error.message));
  }
};
